import React from "react";
import { ShieldCheck, Lock, CheckCircle } from "lucide-react";
import { motion } from "framer-motion";

export default function TrustSection() {
  return (
    <section id="trust" className="py-20 sm:py-28 relative bg-slate-50 border-t border-slate-100">
      
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* Header Content */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <span className="text-[11px] font-bold uppercase tracking-widest text-primary mb-3 block">
            BUILT ON TRUST AND SECURITY
          </span>
          <h2 className="text-4xl md:text-5xl font-black tracking-tight text-slate-900 mb-4">
            Your Data, Fully Protected
          </h2>
          <p className="text-base text-slate-600 font-medium leading-relaxed">
            We employ bank-level encryption and strict privacy protocols to ensure your personal and vehicle data remains completely secure.
          </p>
        </motion.div>

        {/* 3 Column Trust Features */}
        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              icon: <ShieldCheck className="w-5 h-5 text-primary" />,
              title: "End-to-End Encryption",
              description: "All data transmitted and stored on our servers is protected by industry-leading encryption standards.",
            },
            {
              icon: <Lock className="w-5 h-5 text-primary" />,
              title: "Strict Privacy Controls",
              description: "You own your data. We never sell your personal information to third parties without your explicit consent.",
            },
            {
              icon: <CheckCircle className="w-5 h-5 text-primary" />,
              title: "Verified Partners Only",
              description: "Every service provider in our network undergoes a rigorous background check and verification process.",
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-white p-8 rounded-3xl text-center shadow-[0_8px_30px_rgba(0,0,0,0.03)] border border-slate-100 flex flex-col items-center hover:shadow-[0_8px_40px_rgba(0,122,255,0.06)] transition-shadow"
            >
              <div className={`w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center mb-6`}>
                {item.icon}
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-slate-500 font-medium leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}
